import axios from '../utils/axios';

export default function changeCourseRecruiter(adminId, params) {
    return (
        axios.post('/admin/' + adminId + '/courses/course/change-recruiter', params)
    )
}
